import { mount } from './consentBootstrap';

const consentAppDiv = document.getElementById('skagen-consent-app-page');
if (consentAppDiv) {
  mount();
}
